import { useMemo } from 'react';
import { useStore } from 'effector-react';
import { $teamMemberData, $tourRights } from '@stores/memberStores';
import { $tourData } from '@stores/dataStores';

export const MAX_SCENE_NUMBER = 1500;

export function getMaxSceneNumber() {
  const teamMemberData = $teamMemberData.getState();
  const tourRights = $tourRights.getState();
  const { expired } = $tourData.getState();
  const highestLevel = tourRights.reduce((highest, rights) => {
    return rights.expired === 0 && rights.level > highest
      ? rights.level
      : highest;
  }, 0);
  const level = (() => {
    if (expired === 0) return 3;
    if (teamMemberData.role === 0) return highestLevel;
    return 3;
  })();
  let maxScene = MAX_SCENE_NUMBER;
  if (!level) {
    maxScene = 10;
  }
  if (level === 1) {
    maxScene = 50;
  }

  return { level, maxScene };
}

export function useMaxSceneNumber() {
  const teamMemberData = useStore($teamMemberData);
  const tourRights = useStore($tourRights);
  const level = useMemo(() => {
    const highestLevel = tourRights.reduce((highest, rights) => {
      return rights.expired === 0 && rights.level > highest
        ? rights.level
        : highest;
    }, 0);
    return teamMemberData.role === 0 ? highestLevel : 3;
  }, [teamMemberData, tourRights]);
  let maxScene = MAX_SCENE_NUMBER;
  if (!level) {
    maxScene = 10;
  }
  if (level === 1) {
    maxScene = 50;
  }
  return { level, maxScene };
}
